module.exports = __webpack_public_path__ + "img/glot_epic.cb1bef7d.svg";